export default __webpack_public_path__ + "static/media/PUNCHING MACHINE.4d45d6c4.png";